export default {

    error(error, defaultMessage = 'An error occurred.') {
        if (!error?.response?.data?.message) {
            return defaultMessage;
        }
        return error.response.data.message;
    },

}